import { useRemoteClientPost, useRemoteClientPut } from '@/configs/http-client'
import { Endpoints } from '@/remote/endpoints'
import { useLocalStorage } from '@/remote/local-storage'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'
import { Button } from '../components/ui/button'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../components/ui/form'
import { Input } from '../components/ui/input'
import { useToast } from '../hooks'
import { GroupsFormData, groupsSchema } from '../validators/groups-validator'

interface GroupsFormProps {
  data?: GroupsFormData & { id?: number }
  closeDialog?: () => void
  updateList?: () => void
}

export default function GroupsForm({ data, closeDialog, updateList }: GroupsFormProps) {
  const { httpClientPost } = useRemoteClientPost()
  const { httpClientPut } = useRemoteClientPut()
  const { getUnitId } = useLocalStorage()
  const { showToast } = useToast()
  const [params] = useSearchParams()
  const isEditMode = Boolean(data?.id)

  const form = useForm<GroupsFormData>({
    resolver: zodResolver(groupsSchema),
    defaultValues: {
      id: data?.id || 0,
      nome: data?.nome || '',
      descricao: data?.descricao || '',
      unidade: {
        id: data?.unidade?.id || params.get('unit') || getUnitId()
      }
    }
  })

  const onSubmit = async (formData: GroupsFormData) => {
    const formattedData = { ...formData }

    try {
      if (isEditMode) {
        await httpClientPut(Endpoints.gruops, { ...formattedData, inclusao: new Date() })
        closeDialog?.()
        updateList?.()
      } else {
        delete formattedData.id
        await httpClientPost(Endpoints.gruops, { ...formattedData })
        closeDialog?.()
        updateList?.()
      }

      showToast('Requisição enviada com sucesso!', 'success')
      form.reset()
    } catch (error: any) {
      console.error('Erro no envio:', error?.response?.data?.errors)
      const errors = error?.response?.data?.errors
      if (errors) {
        for (const key in errors) {
          showToast(errors[key], 'error')
        }
      }
      showToast('Erro ao enviar requisição', 'error')
    }
  }

  const formValues = form.watch()

  useEffect(() => {
    console.log(formValues)
  }, [formValues])

  const {
    formState: { errors }
  } = form

  useEffect(() => {
    console.log('Erros do formulário:', errors)
  }, [errors])

  return (
    <Form {...form}>
      <form id="formGroup" onSubmit={form.handleSubmit(onSubmit)} className="max-w-128 p-4 w-full flex flex-col m-auto">
        <div className="grid grid-cols-2 gap-3 w-full">
          <FormField
            control={form.control}
            name="nome"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  <span className="text-gray-400">*</span>
                  Nome
                </FormLabel>
                <FormControl>
                  <Input {...field} placeholder="Nome" />
                </FormControl>
                <FormMessage className="text-xs">{form.formState.errors.nome?.message}</FormMessage>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="descricao"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Descrição</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage className="text-xs">{form.formState.errors.descricao?.message}</FormMessage>
              </FormItem>
            )}
          />
        </div>
        {!isEditMode && (
          <Button type="submit" className="bg-acelerafit-green-400 text-muted  font-bold hover:bg-acelerafit-green-300 mt-3 transition-all">
            Enviar
          </Button>
        )}
      </form>
    </Form>
  )
}
